import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { StyledContainerBorder } from './SidekickLayout';
import { THREAD_MODULE_CONTAINER_WIDTH } from './SidekickConstants';

type ModulesContainerProps = {
  children: React.ReactNode;
};

const ModulesContainer = forwardRef(({ children }: ModulesContainerProps, ref: any) => {
  return <StyledModulesContainer ref={ref}>{children}</StyledModulesContainer>;
});

export const StyledModulesContainer = styled.div`
  ${StyledContainerBorder}

  max-width: ${THREAD_MODULE_CONTAINER_WIDTH}px;
  width: 100%;
  padding: 8px 0 24px 0;

  position: absolute;
  left: calc(50% - 250px);
  top: 100px;
`;

export default ModulesContainer;
